export default __webpack_public_path__ + "static/media/progressBarStep3_horizontal.8fc3f293.svg";